<div>
  <header
    *ngIf="showLabel"
    class="font-bold text-l flex align-items-center gap-2 h-3rem">
    <app-data-layer-type-icon [dataLayerType]="dataLayerType" />
    <span>{{ dataLayerType.name }}</span>
    @if (showControls && activeUserStore.canAccessEntityAdder()) {
      <p-menu #menu [model]="menuItems" [popup]="true" appendTo="body" />
      <div class="ml-auto flex align-items-center gap-1">
        @if (forecastLayers.length > 0) {
          <p-button
            size="small"
            [rounded]="true"
            severity="secondary"
            [text]="true"
            pTooltip="Prognosejahre ein-/ausblenden"
            [showDelay]="600"
            styleClass="relative overflow-visible"
            [badge]="forecastLayers.length + ''"
            badgeClass="absolute top-0 right-0 m-0 -mt-1 -mr-1 p-badge-help"
            (click)="showForecastYears = !showForecastYears"
            icon="fas fa-gauge" />
        }
        <p-button
          [rounded]="true"
          severity="secondary"
          [text]="true"
          (click)="menu.toggle($event)"
          icon="fas fa-ellipsis-vertical" />
      </div>
    }
  </header>
  <div class="flex flex-wrap gap-3">
    @if (nonForecastLayers.length === 0) {
      <app-alert
        styleClass="m-0 p-2"
        severity="secondary"
        text="Erforderlich: Neues Jahr hinzufügen"></app-alert>
    }
    <app-year-list
      [dataLayers]="nonForecastLayers"
      [selectionMode]="selectionMode" />
    @if (showForecastYears) {
      <app-year-list
        [dataLayers]="forecastLayers"
        [selectionMode]="selectionMode" />
    }
  </div>
</div>
